export {BdModule} from './core/bd.module';
export {BdService} from './core/bd.service';